import { http, HttpResponse } from "msw";
import { PlessService } from "src/app/shared/pless-service.model";
import { ResponseUtils } from '../response-utils';

export const kymw1301Handlers = [
  http.post(PlessService.SERVICE.getFeatureThemaList.url, async ({ request }) => {
    const req = await request.json();
    return HttpResponse.json(getFeatureThemaListResponce);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),
  http.post(PlessService.SERVICE.getPlanCSV.url, async ({ request }) => {
    const req = await request.json();
    return HttpResponse.json(getPlanCSVResponce);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),
];

const getFeatureThemaListResponce = {
  "status": "ok",
  "message": "処理終了",
  "result": {
    "obj": [
      {
        "FeatureCode": "00001",
        "FeatureName": "０１２３４５６７８９０１２３４５６７８９０１２３４５６７８９",
      },{
        "FeatureCode": "00002",
        "FeatureName": "髙、﨑、102aiu",
      },{
        "FeatureCode": "99999",
        "FeatureName": "特集名3",
      }
    ]
  }
}

const getPlanCSVResponce = {
  "status": "ok",
  "message": "処理完了",
  "result": {
      "obj": {
          "FileName": "/tmp/peace/data/WebData/downloadtemp/1be5b368-e45e-45d3-abfb-07ef6e3af450/KYMW1391_20240729112330.csv"
      }
  }
}